import React, { memo } from 'react'

const IconMenu = ({ color = "#FFFFFF", ...props }) => (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M1.75 4.75H18.25M1.75 10H18.25M1.75 15.25H18.25" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

);

export default memo(IconMenu)